import Vue from 'vue'
import Vuex from 'vuex'

import user from './module/user'


Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		//
	},
	mutations: {
		//
	},
	actions: {
		//
	},
	modules: {
		user
	}
})


// WEBPACK FOOTER //
// ./src/store/index.js